import React, { useState } from 'react';
import { AppProvider, useApp } from './AppContext';
import Header from './components/Header';
import Hero from './components/Hero';
import Approccio from './components/Approccio';
import Servizi from './components/Servizi';
import Faq from './components/Faq';
import Quiz from './components/Quiz';
import BookingWizard from './components/BookingWizard';
import LoginModal from './components/LoginModal';
import Dashboard from './components/Dashboard';
import Footer from './components/Footer';
import Toast from './components/Toast';
import PrivacyPage from './components/legal/PrivacyPage';
import CookiePage from './components/legal/CookiePage';
import TermsPage from './components/legal/TermsPage';
import ResetPasswordPage from './components/auth/ResetPasswordPage';
import { useScrollReveal } from './hooks/useScrollReveal';
import { useScrollEffects } from './hooks/useScrollEffects';
import { useTilt } from './hooks/useTilt';
import { useParallax } from './hooks/useParallax';

function HomePage() {
  useScrollReveal();
  useScrollEffects();
  useTilt();
  useParallax();

  return (
    <>
      <div className="fixed inset-0 pointer-events-none grain-overlay z-50" />
      <div id="scroll-progress" className="fixed top-0 left-0 h-0.5 bg-forest z-[60] w-0" />

      <Header />
      <Hero />
      <Approccio />
      <Servizi />
      <Faq />
      <Quiz />
      <BookingWizard />
      <Footer />

      <LoginModal />
    </>
  );
}

function Router() {
  const { dashboardOpen, page } = useApp();

  if (dashboardOpen) return (<><Dashboard /><Toast /></>);

  let pageEl: React.ReactNode;
  switch (page) {
    case 'privacy': pageEl = <PrivacyPage />; break;
    case 'cookie':  pageEl = <CookiePage />; break;
    case 'terms':   pageEl = <TermsPage />; break;
    default:        pageEl = <HomePage />;
  }

  return (<>{pageEl}<Toast /></>);
}

interface ResetParams { uid: string; token: string }

function parseResetFromUrl(): ResetParams | null {
  const params = new URLSearchParams(window.location.search);
  const raw = params.get('reset');
  if (!raw || !raw.includes(':')) return null;
  const [uid, token] = raw.split(':', 2);
  if (!uid || !token) return null;
  return { uid, token };
}

function clearResetFromUrl() {
  const url = new URL(window.location.href);
  url.searchParams.delete('reset');
  window.history.replaceState({}, '', url.pathname + (url.search || '') + url.hash);
}

function App() {
  const [resetParams, setResetParams] = useState<ResetParams | null>(() => parseResetFromUrl());

  if (resetParams) {
    return (
      <AppProvider>
        <ResetPasswordPage
          uid={resetParams.uid}
          token={resetParams.token}
          onDone={() => { clearResetFromUrl(); setResetParams(null); }}
        />
      </AppProvider>
    );
  }

  return (
    <AppProvider>
      <Router />
    </AppProvider>
  );
}

export default App;
